<div class="alerts">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
</div>

<div class="row">
  <div class="col-xs-8 col-md-10">
    <page-title [title]="titleAccessibilities" class="horario subtitle"></page-title>
  </div>
  <div class="col-xs-4 col-md-2 btAdd">
    <button mat-stroked-button color="primary" (click)="addAccessibility()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<p *ngIf="!accessibilities">Adicione suas acessibilidades.</p>
<div *ngFor="let accessibility of accessibilities; let i = index">
  <mat-card>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Acessibilidades</mat-label>
          <mat-select [(value)]="accessibilities[i].name">
            <mat-option *ngFor="let option of accessibilitiesValues" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card>
</div>

<div class="row">
  <div class="col-xs-8 col-md-10">
    <page-title [title]="titleCourses" class="horario subtitle"></page-title>
  </div>
  <div class="col-xs-4 col-md-2 btAdd">
    <button mat-stroked-button color="primary" (click)="addCourse()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<p *ngIf="!courses">Adicione seus cursos e certificados.</p>
<div *ngFor="let course of courses">
  <mat-card>
    <div class="row">
      <div class="col-xs-12 col-md-8">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Curso</mat-label>
          <input
            type="text"
            matInput
            (ngModelChange)="onChangeForm()"
            [(ngModel)]="course.name"
            placeholder="Nome"
            (keypress)="allowOnlyLetters($event)"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-4">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Data de conclusão</mat-label>
          <input type="text" matInput mask="0000" (ngModelChange)="onChangeForm()" [(ngModel)]="course.dateConclusion" placeholder="Ano" />
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-12">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Instituição</mat-label>
          <input
            type="text"
            matInput
            (ngModelChange)="onChangeForm()"
            [(ngModel)]="course.instituition"
            placeholder="Instituição"
            (keypress)="allowOnlyLetters($event)"
          />
        </mat-form-field>
      </div>
    </div>
  </mat-card>
</div>

<div class="row">
  <div class="col-xs-8 col-md-10">
    <page-title [title]="titleQualifications" class="horario subtitle"></page-title>
  </div>
  <div class="col-xs-4 col-md-2 btAdd">
    <button mat-stroked-button color="primary" (click)="addQualification()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<p *ngIf="!qualifications">Adicione suas qualificações.</p>
<div *ngFor="let qualification of qualifications">
  <mat-card>
    <div class="row">
      <div class="col-xs-12 col-md-7">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Nome da qualificação</mat-label>
          <input
            type="text"
            matInput
            (ngModelChange)="onChangeForm()"
            [(ngModel)]="qualification.name"
            placeholder="Nome"
            (keypress)="allowOnlyLetters($event)"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-5">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Grau de instrução</mat-label>
          <input
            type="text"
            matInput
            (ngModelChange)="onChangeForm()"
            [(ngModel)]="qualification.level"
            placeholder="Grau de instrução"
            (keypress)="allowOnlyLetters($event)"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-7">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Instituição</mat-label>
          <input
            type="text"
            matInput
            (ngModelChange)="onChangeForm()"
            [(ngModel)]="qualification.instituition"
            placeholder="Instituição"
            (keypress)="allowOnlyLetters($event)"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-sm-8 col-md-5">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Data de conclusão</mat-label>
          <input type="text" matInput mask="0000" (ngModelChange)="onChangeForm()" [(ngModel)]="qualification.dateConclusion" placeholder="Ano" />
        </mat-form-field>
      </div>
    </div>
  </mat-card>
</div>

<div class="row">
  <div class="col-xs-8 col-md-10">
    <page-title [title]="titleLanguages" class="horario subtitle"></page-title>
  </div>
  <div class="col-xs-4 col-md-2 btAdd">
    <button mat-stroked-button color="primary" (click)="addLanguage()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<p *ngIf="!languages">Fala mais de um idioma? Adicione aqui.</p>
<div *ngFor="let language of languages">
  <mat-card>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Idioma</mat-label>
          <input
            type="text"
            matInput
            (ngModelChange)="onChangeForm()"
            [(ngModel)]="language.language"
            placeholder="Nome"
            (keypress)="allowOnlyLetters($event)"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-12 col-md-6">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Nível</mat-label>
          <mat-select [(value)]="language.proficiency" (selectionChange)="onChangeForm()">
            <mat-option *ngFor="let level of proficiencyLevels" [value]="level.value">
              {{ level.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card>
</div>

<div class="row">
  <div class="col-xs-12 actions">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving">
      <ng-container *ngIf="!isSaving">Salvar alterações</ng-container>
      <ng-container *ngIf="isSaving">
        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
      </ng-container>
    </button>
  </div>
</div>
